import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigation } from 'react-router-dom';
import Preloader from '../Preloader';
import { requestPending } from '../../util';

/*
  Previously the spinner was always only invoked using the pendingTask actions/reducers,
  but whenever we're using the route loaders, we can simplify by using the navigation.state
  for the spinner
*/
const GlobalPreloader = ({ active }) => {
  const navigation = useNavigation();

  return (
    <Preloader
      active={active || navigation.state !== 'idle'}
    />
  );
};

const mapStateToProps = (state) => ({ active: requestPending(state) });

GlobalPreloader.propTypes = {
  active: PropTypes.bool
};

GlobalPreloader.defaultProps = {
  active: false
};

export default connect(mapStateToProps)(GlobalPreloader);
